//Getting Usercentrics consent array from the consent object
function afUsercentricsConsentArray() {
    const constentObjectTemp = JSON.parse(localStorage.getItem("ucData"));
    const constentObject = constentObjectTemp.consent.services;
    let consentArray = [];
    let tempObject;
    for (const consentArrayKey in constentObject) {
        tempObject = {name: constentObject[consentArrayKey].name, consent:{status:constentObject[consentArrayKey].consent}};
        consentArray.push(tempObject);
    }
    return consentArray;
}

export default afUsercentricsConsentArray;
